import { Service } from '../types/content'

export const services: Service[] = [
  {
    id: 'amor',
    title: 'Amor',
    description:
      'Realizo toda clase de amarres: traigo a tu pareja de vuelta, fortalezco tu matrimonio, tu relación y tu pasión.',
    icon: 'heart',
  },
  {
    id: 'dinero',
    title: 'Dinero',
    description:
      'Hago toda clase de limpieza de aura y retiro toda energía que estorba y cierra tus caminos.',
    icon: 'coins',
  },
  {
    id: 'suerte',
    title: 'Suerte',
    description:
      'Recomiendo lo mejor para tu vida para que conozcas el éxito y tu pareja tenga más de mil razones para amarte y respetarte por siempre.',
    icon: 'clover',
  },
]

export const specialties = ['Videncia', 'Astrología', 'Santería', 'Espiritista']

export const problems = [
  'Amarres',
  'Dominios',
  'Atracción',
  'Separación',
  'Vudú y muertos',
  'Salamientos',
  'Brujería negra',
  'Mala suerte',
]
